<div tabindex="-1" id="attendancePanel" aria-labelledby="attendancePanelLabel">
  <div class="card card-chat-message mb-0 pt-2">
    <div class="card-body p-0">
      <div class="d-flex px-2 justify-content-between gap-1 w-100">
        <button [matMenuTriggerFor]="menu" class="btn btn-soft-primary btn-sm">
          <i class="ri-filter-3-line"></i>
        </button>

        <mat-menu #menu="matMenu">
          <button mat-menu-item [matMenuTriggerFor]="channelMenu">{{ 'attendance.panelList.channel' | translate }}</button>
          <button mat-menu-item [matMenuTriggerFor]="departmentMenu">{{ 'attendance.panelList.department' | translate }}</button>
          <button mat-menu-item [matMenuTriggerFor]="tagMenu">{{ 'attendance.panelList.tag' | translate }}</button>

          @if (!isAdmin() || !isSupervisor()) {
          <button mat-menu-item [matMenuTriggerFor]="userMenu">{{ 'attendance.panelList.agent' | translate }}</button>
          }

          <button mat-menu-item (click)="filterByUnreadMessages(!unreadMessages)" class="flex items-center">
            <mat-checkbox [checked]="unreadMessages" />
            <span> {{ 'attendance.panelList.unread' | translate }} </span>
          </button>
          <button mat-menu-item (click)="clearFilters()">{{ 'attendance.panelList.clearFilters' | translate }}</button>
        </mat-menu>

        <mat-menu #channelMenu="matMenu">
          @for(channel of (listChannel$ | async); track channel._id) {
          <button mat-menu-item>
            <mat-checkbox [checked]="selectedChannelIds.includes(channel._id)" (change)="searchByChannel(channel)">
              {{ channel.name }}
            </mat-checkbox>
          </button>
          }
        </mat-menu>

        <mat-menu #departmentMenu="matMenu">
          @if((listDepartmentFiltered$ | async)?.length > 0) {
          @for(department of (listDepartmentFiltered$ | async); track department._id) {
          <button mat-menu-item>
            <mat-checkbox [checked]="selectedDepartmentIds.includes(department._id)"
              (change)="searchByDepartment(department)">
              {{ department.name }}
            </mat-checkbox>
          </button>
          }
          } @else {
          <button mat-menu-item>
            <mat-checkbox [checked]="true">
              {{ 'attendance.panelList.all' | translate }}
            </mat-checkbox>
          </button>
          }
        </mat-menu>

        <mat-menu #tagMenu="matMenu">
          @for(tag of (listTag$ | async); track tag._id) {
          <button mat-menu-item>
            <mat-checkbox [checked]="selectedTagIds.includes(tag._id)" (change)="searchByTag(tag)">
              {{ tag.title }}
            </mat-checkbox>
          </button>
          }
        </mat-menu>

        <mat-menu #userMenu="matMenu">
          @for(user of (listUser$ | async); track user._id) {
          <button mat-menu-item>
            <mat-checkbox [checked]="selectedUserIds.includes(user._id)" (change)="searchByUser(user)">
              {{ user.name }}
            </mat-checkbox>
          </button>
          }
        </mat-menu>

        @if(showAddContact()) {
        <button [attr.aria-label]="'attendance.panelList.newContact' | translate"
          class="btn btn-soft-primary btn-sm flex-fill d-flex align-items-center justify-content-center gap-1"
          (click)="addContact()">
          <i class="ri-user-add-line"></i>
          <span class="display-text">{{ 'attendance.panelList.newContact' | translate }}</span>
        </button>
        }

        <button color="primary" [attr.aria-label]="'attendance.panelList.newConversation' | translate"
          class="btn btn-soft-primary btn-sm flex-fill d-flex align-items-center justify-content-center gap-1"
          (click)="startNewChat()">
          <i class="ri-question-answer-line"></i>
          <span class="display-text">{{ 'attendance.panelList.newConversation' | translate }}</span>
        </button>
      </div>

      <div class="d-flex p-2 w-100">
        <div class="input-trend-search w-100">
          <input type="search" #searchBox class="form-control" [placeholder]="'attendance.panelList.search' | translate"
            (keyup)="search(searchBox.value)" />
          <span class="mdi mdi-magnify search-icon ml-2"></span>
        </div>
      </div>

      <mat-tab-group class="custom-tab-group" [(selectedIndex)]="selectedIndex" (selectedTabChange)="changeTab($event)"
        animationDuration="400ms">

        <!-- Overtime -->
        <mat-tab [disabled]="loading" [aria-label]="tabAriaLabel('attendance.panelList.overtime', STATUS.OVERTIME, overtimeCount)">
          <ng-template mat-tab-label>
            <span [matTooltip]="'attendance.panelList.overtime' | translate" class="tab-status flex-fill d-flex align-items-center justify-content-center">
              <span class="tab-status-icon">
                <i class="ri-alert-line"></i>
                @if (unreadOf(STATUS.OVERTIME) > 0) {
                <span class="tab-unread-badge bg-success">{{ unreadLabel(STATUS.OVERTIME) }}</span>
                }
              </span>
              <span class="tab-status-total">{{ overtimeCount }}</span>
            </span>
          </ng-template>

          @defer (when selectedIndex === 0) {
          @if(blockSocketWhenFilterIsActive) {
          <button type="button" class="btn btn-secondary rounded-pill d-flex my-3 m-auto gap-1"
            (click)="clearFilters()">
            <i class="mdi mdi-close"></i>
            {{ (unreadMessages ? 'attendance.panelList.clearUnread' : 'attendance.panelList.clearSearch') | translate }}
          </button>
          }

          <div class="px-2 pt-2 pb-5 position-relative" (scroll)="onScroll($event)" #scrollContainer>

            @if (pinnedAttendances.length > 0) {
            @for(item of pinnedAttendances; track item._id) {
            <attendance-contact-card-component [item]="item" [pinned]="true"
              [selected]="item._id === idAttendanceParam || item._id === attendance?._id"
              (click)="!loading && selectAttendance(item)" />
            }
            <hr />
            }

            @if(pager.total > 0) {
            @for(item of pager.list; track item._id) {
            <attendance-contact-card-component [item]="item"
              [selected]="item._id === idAttendanceParam || item._id === attendance?._id"
              (click)="!loading && selectAttendance(item)" />
            }
            }

            <attendance-message-hits-component [state]="messageHits" (select)="openMessageHit($event)"
              (loadMore)="loadMoreMessageHits()" (retry)="retryMessageHits()" />

            @if(pager.total === 0 && !hasMessageResults) {
            <p class="custom-no-message">
              <strong>{{ 'attendance.panelList.emptyOvertime' | translate }}</strong>
              <i class="ri-alert-line custom-icon-message-bg"></i>
            </p>
            }
          </div>
          }
        </mat-tab>

        <!-- Pending -->
        <mat-tab [disabled]="loading" [aria-label]="tabAriaLabel('attendance.panelList.pending', STATUS.PENDING, pendingCount)">
          <ng-template mat-tab-label>
            <span [matTooltip]="'attendance.panelList.pending' | translate" class="tab-status flex-fill d-flex align-items-center justify-content-center">
              <span class="tab-status-icon">
                <i class="ri-time-line"></i>
                @if (unreadOf(STATUS.PENDING) > 0) {
                <span class="tab-unread-badge bg-success">{{ unreadLabel(STATUS.PENDING) }}</span>
                }
              </span>
              <span class="tab-status-total">{{ pendingCount }}</span>
            </span>
          </ng-template>

          @defer (when selectedIndex === 1) {
          @if(blockSocketWhenFilterIsActive) {
          <button type="button" class="btn btn-sm btn-secondary rounded-pill d-flex my-3 m-auto gap-1"
            (click)="clearFilters()">
            <i class="mdi mdi-close"></i>
            {{ (unreadMessages ? 'attendance.panelList.clearUnread' : 'attendance.panelList.clearSearch') | translate }}
          </button>
          }

          <div class="px-2 pt-2 pb-5 position-relative" (scroll)="onScroll($event)" #scrollContainer>

            @if (pinnedAttendances.length > 0) {
            @for(item of pinnedAttendances; track item._id) {
            <attendance-contact-card-component [item]="item" [pinned]="true"
              [selected]="item._id === idAttendanceParam || item._id === attendance?._id"
              (click)="!loading && selectAttendance(item)" />
            }
            <hr />
            }

            @if(pager.total > 0) {
            @for(item of pager.list; track item._id) {
            <attendance-contact-card-component [item]="item"
              [selected]="item._id === idAttendanceParam || item._id === attendance?._id"
              (click)="!loading && selectAttendance(item)" />
            }
            }

            <attendance-message-hits-component [state]="messageHits" (select)="openMessageHit($event)"
              (loadMore)="loadMoreMessageHits()" (retry)="retryMessageHits()" />

            @if(pager.total === 0 && !hasMessageResults) {
            <p class="custom-no-message">
              <strong>{{ 'attendance.panelList.emptyPending' | translate }}</strong>
              <i class="ri-time-line custom-icon-message-bg"></i>
            </p>
            }
          </div>
          }
        </mat-tab>

        <!-- In Progress -->
        <mat-tab [disabled]="loading" [aria-label]="tabAriaLabel('attendance.panelList.inProgress', STATUS.IN_PROGRESS, inProgressCount)">
          <ng-template mat-tab-label>
            <span [matTooltip]="'attendance.panelList.inProgress' | translate" class="tab-status flex-fill d-flex align-items-center justify-content-center">
              <span class="tab-status-icon">
                <i class="ri-message-2-line"></i>
                @if (unreadOf(STATUS.IN_PROGRESS) > 0) {
                <span class="tab-unread-badge bg-success">{{ unreadLabel(STATUS.IN_PROGRESS) }}</span>
                }
              </span>
              <span class="tab-status-total">{{ inProgressCount }}</span>
            </span>
          </ng-template>

          @defer (when selectedIndex === 2) {
          @if(blockSocketWhenFilterIsActive) {
          <button type="button" class="btn btn-secondary rounded-pill d-flex my-3 m-auto gap-1"
            (click)="clearFilters()">
            <i class="mdi mdi-close"></i>
            {{ (unreadMessages ? 'attendance.panelList.clearUnread' : 'attendance.panelList.clearSearch') | translate }}
          </button>
          }

          <div class="px-2 pt-2 pb-5 position-relative" (scroll)="onScroll($event)" #scrollContainer>

            @if (pinnedAttendances.length > 0) {
            @for(item of pinnedAttendances; track item._id) {
            <attendance-contact-card-component [item]="item" [pinned]="true"
              [selected]="item._id === idAttendanceParam || item._id === attendance?._id"
              (click)="!loading && selectAttendance(item)" />
            }
            <hr />
            }

            @if(pager.total > 0) {
            @for(item of pager.list; track item._id) {
            <attendance-contact-card-component [item]="item"
              [selected]="item._id === idAttendanceParam || item._id === attendance?._id"
              (click)="!loading && selectAttendance(item)" />
            }
            }

            <attendance-message-hits-component [state]="messageHits" (select)="openMessageHit($event)"
              (loadMore)="loadMoreMessageHits()" (retry)="retryMessageHits()" />

            @if(pager.total === 0 && !hasMessageResults) {
            <p class="custom-no-message">
              <strong>{{ 'attendance.panelList.emptyInProgress' | translate }}</strong>
              <i class="ri-message-2-line custom-icon-message-bg"></i>
            </p>
            }
          </div>
          }
        </mat-tab>

        <!-- Paused -->
        <mat-tab [disabled]="loading" [aria-label]="tabAriaLabel('attendance.panelList.paused', STATUS.PAUSED, pausedCount)">
          <ng-template mat-tab-label>
            <span [matTooltip]="'attendance.panelList.paused' | translate" class="tab-status flex-fill d-flex align-items-center justify-content-center">
              <span class="tab-status-icon">
                <i class="ri-message-line"></i>
                @if (unreadOf(STATUS.PAUSED) > 0) {
                <span class="tab-unread-badge bg-success">{{ unreadLabel(STATUS.PAUSED) }}</span>
                }
              </span>
              <span class="tab-status-total">{{ pausedCount }}</span>
            </span>
          </ng-template>

          @defer (when selectedIndex === 3) {
          @if(blockSocketWhenFilterIsActive) {
          <button type="button" class="btn btn-secondary rounded-pill d-flex my-3 m-auto gap-1"
            (click)="clearFilters()">
            <i class="mdi mdi-close"></i>
            {{ (unreadMessages ? 'attendance.panelList.clearUnread' : 'attendance.panelList.clearSearch') | translate }}
          </button>
          }

          <div class="px-2 pt-2 pb-5 position-relative" (scroll)="onScroll($event)" #scrollContainer>

            @if (pinnedAttendances.length > 0) {
            @for(item of pinnedAttendances; track item._id) {
            <attendance-contact-card-component [item]="item" [pinned]="true"
              [selected]="item._id === idAttendanceParam || item._id === attendance?._id"
              (click)="!loading && selectAttendance(item)" />
            }
            <hr />
            }

            @if(pager.total > 0) {
            @for(item of pager.list; track item._id) {
            <attendance-contact-card-component [item]="item"
              [selected]="item._id === idAttendanceParam || item._id === attendance?._id"
              (click)="!loading && selectAttendance(item)" />
            }
            }

            <attendance-message-hits-component [state]="messageHits" (select)="openMessageHit($event)"
              (loadMore)="loadMoreMessageHits()" (retry)="retryMessageHits()" />

            @if(pager.total === 0 && !hasMessageResults) {
            <p class="custom-no-message">
              <strong>{{ 'attendance.panelList.emptyPaused' | translate }}</strong>
              <i class="ri-message-line custom-icon-message-bg"></i>
            </p>
            }
          </div>
          }
        </mat-tab>

        <!-- Closed -->
        <mat-tab [disabled]="loading" [aria-label]="tabAriaLabel('attendance.panelList.closed', STATUS.CLOSED, closedCount)">
          <ng-template mat-tab-label>
            <span [matTooltip]="'attendance.panelList.closed' | translate" class="tab-status flex-fill d-flex align-items-center justify-content-center">
              <span class="tab-status-icon">
                <i class="ri-chat-delete-line"></i>
                @if (unreadOf(STATUS.CLOSED) > 0) {
                <span class="tab-unread-badge bg-success">{{ unreadLabel(STATUS.CLOSED) }}</span>
                }
              </span>
              <span class="tab-status-total">{{ closedCount }}</span>
            </span>
          </ng-template>

          @defer (when selectedIndex === 4) {
          <!-- @if(blockSocketWhenFilterIsActive) {
                  <button
                    type="button"
                    class="btn btn-secondary rounded-pill d-flex my-3 m-auto gap-1"
                    (click)="clearFilters()"
                  >
                    <i class="mdi mdi-close"></i>
                    {{ unreadMessages ? 'Limpar não lidas' : 'Limpar busca' }}
                  </button>
                } -->

          <div class="px-2 pt-2 pb-5 position-relative" (scroll)="onScroll($event)" #scrollContainer>

            @if(pager.total > 0) {
            @for(item of pager.list; track item._id) {
            <attendance-contact-card-component [item]="item"
              [selected]="item._id === idAttendanceParam || item._id === attendance?._id"
              (click)="!loading && selectAttendance(item)" />
            }
            }

            <attendance-message-hits-component [state]="messageHits" (select)="openMessageHit($event)"
              (loadMore)="loadMoreMessageHits()" (retry)="retryMessageHits()" />

            @if(pager.total === 0 && !hasMessageResults) {
            <p class="custom-no-message">
              <strong>{{ 'attendance.panelList.emptyClosed' | translate }}</strong>
              <i class="ri-chat-delete-line custom-icon-message-bg"></i>
            </p>
            }
          </div>
          }
        </mat-tab>
      </mat-tab-group>

      @if(pager.list.length < pager.total) { <button type="button"
        class="btn btn-soft-primary rounded-pill d-flex m-auto mt-2 mb-1 gap-1 custom-load-more"
        [ngClass]="{ 'is-loading' : loading }" (click)="loadMoreContacts()">
        @if(loading) {
        <mat-spinner [diameter]="16" [color]="'primary'" mode="indeterminate" />
        } @else {
        <i class="ri-add-line"></i>
        <strong>{{ 'attendance.panelList.loadMore' | translate }}</strong>
        }
        </button>
        }
    </div>

  </div>

</div>
